import { ComponentTheme } from "hardcover-ui/types/base";

export type LabelThemeProps = {
  variant: "primary";
  size: "sm" | "md" | "lg";
};

const labelBaseStyles = "text-gray-900 dark:text-gray-100";

export const labelTheme: ComponentTheme<LabelThemeProps> = {
  variant: {
    primary: `${labelBaseStyles} font-semibold cursor-pointer`,
  },
  size: {
    sm: "text-xs sm:text-sm leading-4",
    md: "text-sm sm:text-base leading-4",
    lg: "text-lg sm:text-xl leading-4",
  },
};
